import { IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';

export class CreateLobbyPlayerDto {
	@IsString()
	@IsNotEmpty()
	firstname!: string;

	@IsString()
	@IsNotEmpty()
	lastname!: string;

	@IsOptional()
	@Type(() => Number)
	@IsNumber()
	rate?: number;

	@IsOptional()
	@IsString()
	link?: string;

	@IsOptional()
	img_variants?: any | null;
}
